import currentUser from "./currentUser";
import currentCustomer from "./currrentCustomer";
import { combineReducers } from "redux";

const rootReducer = combineReducers({
    currentUser,
    currentCustomer
})

export default rootReducer